import React from 'react';
import { motionTag } from './Reveal';

/**
 * Premium card: solid surface, 1px hairline border and a soft shadow. `interactive` adds a hover
 * lift, a stronger shadow and a solid primary border. `<GlowCard as="div" className interactive>…</GlowCard>`
 * Any `as` that accepts a ref works (e.g. 'a', 'li', or react-router's Link).
 */
const GlowCard = React.forwardRef(function GlowCard({ as = 'div', className = '', interactive = false, children, ...rest }, ref) {
  const Tag = motionTag(as);
  return (
    <Tag
      ref={ref}
      whileHover={interactive ? { y: -4 } : undefined}
      transition={{ type: 'spring', stiffness: 320, damping: 26 }}
      className={`hairline group/glow relative block overflow-hidden rounded-3xl bg-surface shadow-soft transition-[box-shadow,border-color] duration-300 ${interactive ? 'hover:border-primary/50 hover:shadow-lift' : ''} ${className}`}
      {...rest}
    >
      <div className="relative z-[2] h-full">{children}</div>
    </Tag>
  );
});

export default GlowCard;
